import webContextProvider from "../../../../../../../providers/webContextProvider";

const getPageName = () => {
  const { platform, storeId } = webContextProvider();

  return `${platform} ${storeId}|saved items`;
};

export default getPageName;
